
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ActivationEnd, Router } from '@angular/router';
import { ApsServiceService } from '../aps-service.service';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';
import { element } from 'protractor';
import { timeout } from 'rxjs/operators';
import * as fs from 'fs';
import * as XLSX from 'xlsx-style';
import { timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Renderer2, ElementRef } from '@angular/core';
@Component({
  selector: 'app-categoryitems',
  templateUrl: './categoryitems.component.html',
  styleUrls: ['./categoryitems.component.css']
})
export class CategoryitemsComponent implements OnInit {
  loaderdata: any = false;
  data: any = "";
  category: string = "";
  items: any;
  displayItems: any[] = [];
  seacrhItems: any[] = [];
  currentPage: number;
  totalItems: number;
  loading: boolean = false;
  showFirstPage: boolean = false;
  showLastPage: boolean = false;
  searchterm: any;
  datafromapi: any;
  allUrls: { name: string; url: string }[] = [];
  qitems:any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private searchitem: ApsServiceService,
    private toastr: ToastrService,
    private renderer: Renderer2, private el: ElementRef
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof ActivationEnd) {
       // console.log("navigation start");
        this.getCategoryItems();
      }
    });
  }

  ngOnInit(): void {
    // this.checkData();
  }

 


  getCategoryItems(): void {
    this.loaderdata = true;
    this.category = this.route.snapshot.params.page;
    this.searchitem.getsearchdocs().subscribe((response) => {
      const categoryData = response.datas.find(
        (element) => element.searchcataname == this.category
      );
      this.items = categoryData ? categoryData.searchdata : [];
      this.totalItems = this.items.length;
      this.currentPage = 1;
      // this.fetchURl();
      this.updateDisplayItems();
      this.loaderdata = false;
    });
  }

  downlaodUrl(fileName: string,url:string): void {
    this.loaderdata = true;
    window.open(url, '_blank');
          this.loaderdata = false;
  // console.log(fileName+'.txt');
    // this.searchitem.basesearch(fileName + '.txt').subscribe((getresponce) => {
    //   console.log(getresponce);
    //   this.qitems = getresponce.value.length;
    //   if (this.qitems > 0) {
    //     this.datafromapi = getresponce.value;
    //   //   console.log(this.datafromapi);
  
    //     const matchingItem = getresponce.value.find((item: any) => {
    //       const wfileurl = item.wfileurl;
  
    //       return wfileurl.includes(fileName);
    //     });
  
    //     if (matchingItem) {
    //     //  console.log("Matching URL:", matchingItem.wfileurl);
    //       window.open(matchingItem.wfileurl, '_blank');
    //       this.loaderdata = false;
    //     } else {
    //    //   console.log("No matching URL found.");
    //     }
    //   } else {
    //     this.toastr.error("No Item Found")
    //   }
    // });
  }
  

  //for both safari and chrome!
  // downlaodUrl(fileName: string): void {
  //   this.loaderdata = true;
  //   //console.log(fileName);
  //   this.searchitem.basesearch(fileName).subscribe((getResponse) => {
  //     this.qitems = getResponse.value.length;
  //     if (this.qitems > 0) {
  //       this.datafromapi = getResponse.value;
  
  //       const matchingItem = getResponse.value.find((item: any) => {
  //         const wfileurl = item.wfileurl;
  //         return wfileurl.includes(fileName);
  //       });
  
  //       if (matchingItem) {
  //         const link = this.renderer.createElement('a');
  //         this.renderer.setAttribute(link, 'href', matchingItem.wfileurl);
  //         this.renderer.setStyle(link, 'display', 'none');
  //         this.renderer.appendChild(this.el.nativeElement, link);
  //         link.click();
  //         this.loaderdata = false;
  //       } else {
  //         console.log('No matching URL found.');
  //       }
  //     } else {
  //       this.toastr.error('No Item Found');
  //     }
  //   });
  // }
  
  // downlaodUrl(fileName: string): void {
  //   this.loaderdata = true;
  //   //console.log(fileName);
  //   this.searchitem.basesearch(fileName).subscribe((getResponse) => {
  //     this.qitems = getResponse.value.length;
  //     if (this.qitems > 0) {
  //       this.datafromapi = getResponse.value;
  
  //       const matchingItem = getResponse.value.find((item: any) => {
  //         const wfileurl = item.wfileurl;
  //         return wfileurl.includes(fileName);
  //       });
  
  //       if (matchingItem) {
  //         var windowReference = window.open(matchingItem.wfileurl, '_blank');
  //         windowReference.focus();
  
  //         this.loaderdata = false;
  //       } else {
  //         console.log('No matching URL found.');
  //       }
  //     } else {
  //       this.toastr.error('No Item Found');
  //     }
  //   });
  // }
  
  
  updateDisplayItems(): void {
    const startIndex = (this.currentPage - 1) * 12;
    const endIndex = startIndex + 12;
    this.displayItems = this.items.slice(startIndex, endIndex);
    this.updatePagination();
  }

  onPageChange(page: number): void {
    if (page === 2 && this.currentPage === 1) {
      this.loading = true;
      window.scrollTo({ top: 0, behavior: 'smooth' });

      setTimeout(() => {
        this.loading = false;
        this.currentPage = page;
        this.updateDisplayItems();
      }, 2000);
    } else {
      this.currentPage = page;
      this.updateDisplayItems();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  onFirstPage(): void {
    this.currentPage = 1;
    this.updateDisplayItems();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  onLastPage(): void {
    this.currentPage = this.getTotalPages();
    this.updateDisplayItems();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
   bookTitle(name:String): string {
    return name.replace(/\.[^/.]+$/, "");
  }
  updatePagination(): void {
    const totalPages = this.getTotalPages();
    const maxPages = 10;

    if (totalPages > maxPages) {
      const halfMaxPages = Math.floor(maxPages / 2);
      this.showFirstPage = this.currentPage > halfMaxPages + 1;
      this.showLastPage = this.currentPage < totalPages - halfMaxPages;
    } else {
      this.showFirstPage = false;
      this.showLastPage = false;
    }
  }

  // getPaginationArray(): number[] {
  //   const totalPages = this.getTotalPages();
  //   const maxPages = 10;
  //   const paginationArray = [];

  //   if (totalPages <= maxPages) {
  //     for (let i = 1; i <= totalPages; i++) {
  //       paginationArray.push(i);
  //     }
  //   } else {
  //     const halfMaxPages = Math.floor(maxPages / 2);
  //     const startPage = Math.max(this.currentPage - halfMaxPages, 1);
  //     const endPage = Math.min(this.currentPage + halfMaxPages, totalPages);

  //     if (this.currentPage - startPage < halfMaxPages) {
  //       for (let i = 1; i <= maxPages - 2; i++) {
  //         paginationArray.push(i);
  //       }
  //       paginationArray.push('...');
  //       paginationArray.push(totalPages);
  //     } else if (endPage - this.currentPage < halfMaxPages) {
  //       paginationArray.push(1);
  //       paginationArray.push('...');
  //       for (let i = totalPages - maxPages + 3; i <= totalPages; i++) {
  //         paginationArray.push(i);
  //       }
  //     } else {
  //       paginationArray.push(1);
  //       paginationArray.push('...');
  //       for (let i = startPage; i <= endPage; i++) {
  //         paginationArray.push(i);
  //       }
  //       paginationArray.push('...');
  //       paginationArray.push(totalPages);
  //     }
  //   }

  //   return paginationArray;
  // }
  getPaginationArray(): (number | string)[] {
    const totalPages = this.getTotalPages();
    const maxPages = 10;
    const paginationArray: (number | string)[] = [];
  
    if (totalPages <= maxPages) {
      for (let i = 1; i <= totalPages; i++) {
        paginationArray.push(i);
      }
    } else {
      const halfMaxPages = Math.floor(maxPages / 2);
      const startPage = Math.max(this.currentPage - halfMaxPages, 1);
      const endPage = Math.min(this.currentPage + halfMaxPages, totalPages);
  
      if (this.currentPage - startPage < halfMaxPages) {
        for (let i = 1; i <= maxPages - 2; i++) {
          paginationArray.push(i);
        }
        paginationArray.push(totalPages);
      } else if (endPage - this.currentPage < halfMaxPages) {
        paginationArray.push(1);
        for (let i = totalPages - maxPages + 2; i <= totalPages; i++) {
          paginationArray.push(i);
        }
      } else {
        paginationArray.push(1);
        for (let i = startPage; i <= endPage; i++) {
          paginationArray.push(i);
        }
        paginationArray.push(totalPages);
      }
    }
  
    return paginationArray;
  }
  

  getTotalPages(): number {
    return Math.ceil(this.totalItems / 12);
  }
}


 // 
  // getCategoryItems(): void {
  //   this.loaderdata = true;
  //   this.category = this.route.snapshot.params.page;
  //   this.searchitem.basesearch(this.category).subscribe((getresponse) => {
  //     if (getresponse && getresponse.value) {
  //       const categoryData = getresponse.value;
  //       if (categoryData) {
  //         this.items = categoryData;
  //         this.totalItems = this.items.length;
  //         this.currentPage = 1;
  //         this.updateDisplayItems();
  
  //         // Log categoryData object
  //         console.log('categoryData:', categoryData);
  //       }
  //     }
  //     this.loaderdata = false;
  //   });
  // }
  // getSearchItems():void{
  //   this.searchitem.basesearch(this.category).subscribe((getresponce) => {
  //     this.seacrhItems=getresponce.value
  //   });
  // }
  // getMyUrl(bookName:string):string{
  //   if(this.seacrhItems.length==0){

  //   }
  //   const match = this.seacrhItems.find((otherItem) => otherItem.metadata_storage_name.replace(/\.[^/.]+$/, "") === bookName);
  //     if (match) {
  //      return "EdaKitty";
  //     }
  //     return "EdaPatty";

  //   // this.displayItems.forEach((displayItem, index) => {
  //   //   const match = this.seacrhItems.find((otherItem) => otherItem.metadata_storage_name.replace(/\.[^/.]+$/, "") === displayItem.searchname);
  //   //   if (match) {
  //   //     // console.log(displayItem.url)
  //   //     this.displayItems[index].url="EdaKitty";
  //   //     // displayItem.url = match.wfileurl;
  //   //   }
  //   //   else{
  //   //     this.displayItems[index].url="PodaPatty";

  //   //   }
  //   // })
  //   return "Hi Njan Sanju";
  // }
  

  // getCategoryItems(): void {
  //   this.loaderdata = true;
  //   this.category = this.route.snapshot.params.page;
  //   this.searchitem.getsearchdocs().subscribe((response) => {
  //     const categoryData = response.datas.find(
  //       (element) => element.searchcataname == this.category
  //     );
  //     this.items = categoryData ? categoryData.searchdata : [];
  //     this.totalItems = this.items.length;
  //     this.currentPage = 1;
  //     this.updateDisplayItems();
  //     this.loaderdata = false;
  //     this.getSearchItems();this.searchitem.basesearch(this.category).subscribe((getresponce) => {

  //       this.seacrhItems=getresponce.value
        
  //       this.displayItems.forEach((displayItem, index) => {
  //         const match = this.seacrhItems.find((otherItem) => otherItem.metadata_storage_name.replace(/\.[^/.]+$/, "") === displayItem.searchname);
  //         if (match) {

  //           this.displayItems[index].url="EdaKitty";
  //           // displayItem.url = match.wfileurl;
  //         }
  //         else{
  //           this.displayItems[index].url="PodaPatty";

  //         }
  //       })

  //       this.searchterm = '';

  //     });
  //   });
  // }
 
  // checkData() :void 
  // {
  //   this.category = this.route.snapshot.params.page;
  //   this.searchitem.basesearch(this.category).subscribe((getresponce) => {
  //     console.log(getresponce.value);
  //     console.log(this.displayItems);
  //     // for()
  //     //this.qitems = getresponce.value.length;
  //   //  if(this.qitems > 0){
  //   //  this.datafromapi = getresponce.value;
  //     //console.log(this.qitems);
  //   //   }else{

  //   //     this.toastr.error("No Item Found")
  //   //   }
  //   //   this.loaderitem = false;
  //     this.searchterm='';

  //   });
  // }
  //Get all url name
  // fetchAllUrls(): void {
  //   this.loaderdata = true;
  //   const request1 = this.searchitem.basesearch('*&$top=1000');
  //   const request2 = this.searchitem.basesearch('%2A&$top=500&$skip=1000');
  
  //   forkJoin([request1, request2]).subscribe(([response1, response2]) => {
  //     const urls: { name: string; url: string }[] = [];
  
  //     if (response1?.value?.length > 0) {
  //       response1.value.forEach((element: any) => {
  //         const name = element.metadata_storage_name.split('.')[0];
  //         const url = element.wfileurl;
  //         urls.push({ name, url });
  //       });
  //     }
  
  //     if (response2?.value?.length > 0) {
  //       response2.value.forEach((element: any) => {
  //         const name = element.metadata_storage_name.split('.')[0];
  //         const url = element.wfileurl;
  //         urls.push({ name, url });
  //       });
  //     }
  
  //     this.allUrls = urls;
  //     this.loaderdata = false;
  
  //     const length = this.allUrls.length;
  //     console.log("Total URLs:", length);
  //     console.log("All URLs:", this.allUrls);
  
  //     // Extract filenames
  //     const filenames: string[] = this.allUrls.map(url => url.url.split("/").pop());
  //     console.log("Filenames:", filenames);
  //     filenames.forEach((filename, index) => {
  //       console.log(`${filename}`);
  //     });
  //     // Continue with other logic if needed
  //   });
  // }
  
  // downlaodUrl(fileName: string): void {
  //   const matchedItem = this.allUrls.find(item => item.name === fileName);
  //   if (matchedItem) {
  //     console.log(`Name "${fileName}" exists in the allUrls array.`);
  //     console.log("Matched URL:", matchedItem.url);
  //     window.open(matchedItem.url, '_blank');
  //   } else {
  //     console.log(`Name "${fileName}" does not exist in the allUrls array.`);
  //   }
  // }
// getCategoryItems(): void {
  //   this.loaderdata = true;
  //   this.category = this.route.snapshot.params.page;  
  //   this.searchitem.getsearchdocs().subscribe((response) => {
  //     const categoryData = response.datas.find(
  //       (element) => element.searchcataname == this.category
  //     );
  //     this.items = categoryData ? categoryData.searchdata : [];
  //     this.totalItems = this.items.length;
  //     this.currentPage = 1;
  //     this.updateDisplayItems();
  //     this.loaderdata = false;
  //   });
    
  // }

  // downlaodUrl(fileName): void {
  //   this.loaderdata = true;
  //   const forSearch = fileName;
  //   console.log(fileName);
  //   let matchedUrl: string | undefined;
  
  //   this.searchitem.basesearch('*&$top=1000').subscribe((getresponse) => {
  //     this.loaderdata = true;
  //     const fullResponse = getresponse.value.length;
  //     const starNamesArray: string[] = [];
  
  //     if (fullResponse > 0) {
  //       this.datafromapi = getresponse.value;
  //       this.datafromapi.forEach((element) => {
  //         const starName = element.metadata_storage_name.split('.')[0];
  //         starNamesArray.push(starName);
  //       });
  //     }
  
  //     this.searchitem.basesearch('%2A&$top=500&$skip=1000').subscribe((getresponse) => {
  //       const fullResponses = getresponse.value.length;
  //       const secoundNamesArray: string[] = [];
  
  //       if (fullResponses > 0) {
  //         this.datafromapi = getresponse.value;
  //         this.datafromapi.forEach((element) => {
  //           const secoundStarName = element.metadata_storage_name.split('.')[0];
  //           secoundNamesArray.push(secoundStarName);
  //         });
  //       }
  
  //       const combinedArray = [...starNamesArray, ...secoundNamesArray];
  //       console.log("Combined Array:", combinedArray);
  //       const length = combinedArray.length;
  //       console.log("Total length: " + length);
  //       this.loaderdata = false;
  
  //       if (combinedArray.includes(forSearch)) {
  //         console.log(`Name "${forSearch}" exists in the combinedArray.`);
  
  //         const matchedItem = this.datafromapi.find(item => item.metadata_storage_name.split('.')[0] === forSearch);
  //         if (matchedItem) {
  //           matchedUrl = matchedItem.wfileurl;
  //           this.loaderdata = false;
            
  //         }
  //         window.open(matchedUrl, '_blank')
  //       } else {
  //         console.log(`Name "${forSearch}" does not exist in the combinedArray.`);
  //       }
  
  //       console.log("Matched URL:", matchedUrl);
  //     });
  //   });
  // }
 // fetchAllUrls(): void {
    //   this.loaderdata = true;
    //   const request1 = this.searchitem.basesearch('*&$top=1000');
    //   const request2 = this.searchitem.basesearch('%2A&$top=500&$skip=1000');
    
    //   forkJoin([request1, request2]).subscribe(([response1, response2]) => {
    //     const urls: { name: string; url: string }[] = [];
    
    //     if (response1?.value?.length > 0) {
    //       response1.value.forEach((element: any) => {
    //         const name = element.metadata_storage_name.split('.')[0];
    //         const url = element.wfileurl;
    //         urls.push({ name, url });
    //         console.log(name); // Print metadata_storage_name for API 1
    //       });
    //     }
    
    //     if (response2?.value?.length > 0) {
    //       response2.value.forEach((element: any) => {
    //         const name = element.metadata_storage_name.split('.')[0];
    //         const url = element.wfileurl;
    //         urls.push({ name, url });
    //         console.log(name); // Print metadata_storage_name for API 2
    //       });
    //     }
    
    //     this.allUrls = urls;
    //     this.loaderdata = false;
    //     const length = this.allUrls.length;
    //     console.log(length);
    //     console.log("haaa :" + this.allUrls);
    //   });
    // }
    
  

  // getCategoryItems(): void {
  //   this.loaderdata = true;
  //   this.category = this.route.snapshot.params.page;
  //   this.searchitem.getsearchdocs().subscribe((response) => {
  //     const categoryData = response.datas.find(
  //       (element) => element.searchcataname === this.category
  //     );
  //     this.items = categoryData ? categoryData.searchdata : [];
  //     this.totalItems = this.items.length;
  //     this.currentPage = 1;
  //     this.updateDisplayItems();
  //     this.loaderdata = false;
  //   });
  // }
  
  // downlaodUrl(fileName: string): void {
  //   this.loaderdata = true;
  
  //   this.searchitem.basesearch(fileName + '&$top=1000').subscribe(
  //     (response1) => {
  //       const urls: { name: string; url: string }[] = [];
  
  //       if (response1?.value?.length > 0) {
  //         response1.value.forEach((element: any) => {
  //           const name = element.metadata_storage_name.split('.')[0];
  //           const url = element.wfileurl;
  //           urls.push({ name, url });
  //         });
  //       }
  
  //       if (urls.length > 0) {
  //         // Filename found in the first API response, open the URL
  //         console.log(`Name "${fileName}" exists in the first API response.`);
  //         console.log("Matched URL:", urls[0].url);
  //         window.open(urls[0].url, '_blank');
  //         this.loaderdata = false;
  //       } else {
  //         // Filename not found in the first API response, make second API call
  //         this.searchitem.basesearch(fileName + '&$top=500&$skip=1000').subscribe(
  //           (response2) => {
  //             if (response2?.value?.length > 0) {
  //               response2.value.forEach((element: any) => {
  //                 const name = element.metadata_storage_name.split('.')[0];
  //                 const url = element.wfileurl;
  //                 urls.push({ name, url });
  //               });
  //             }
  
  //             if (urls.length > 0) {
  //               // Filename found in the second API response, open the URL
  //               console.log(`Name "${fileName}" exists in the second API response.`);
  //               console.log("Matched URL:", urls[0].url);
  //               window.open(urls[0].url, '_blank');
  //             } else {
  //               // Filename not found in both API responses
  //               console.log(`No URLs found for "${fileName}".`);
  //             }
  
  //             this.loaderdata = false;
  //           },
  //           (error) => {
  //             console.log("Error occurred:", error);
  //             this.loaderdata = false;
  //             alert("Error occurred while fetching URLs.");
  //           }
  //         );
  //       }
  //     },
  //     (error) => {
  //       console.log("Error occurred:", error);
  //       this.loaderdata = false;
  //       alert("Error occurred while fetching URLs.");
  //     }
  //   );
  // }


  //working
  // fetchAllUrls(): void {
  //   this.loaderdata = true;
  //   const request1 = this.searchitem.basesearch('*&$top=1000');
  //   const request2 = this.searchitem.basesearch('%2A&$top=500&$skip=1000');

  //   forkJoin([request1, request2]).subscribe(([response1, response2]) => {
  //     const urls: { name: string; url: string }[] = [];

  //     if (response1?.value?.length > 0) {
  //       response1.value.forEach((element: any) => {
  //         const name = element.metadata_storage_name.split('.')[0];
  //         const url = element.wfileurl;
  //         urls.push({ name, url });
  //       });
  //     }

  //     if (response2?.value?.length > 0) {
  //       response2.value.forEach((element: any) => {
  //         const name = element.metadata_storage_name.split('.')[0];
  //         const url = element.wfileurl;
  //         urls.push({ name, url });
  //       });
  //     }

  //     this.allUrls = urls;
  //     this.loaderdata = false;
  //     const length = this.allUrls.length;
  //     console.log(length);
  //     console.log("haaa :"+this.allUrls)
  //   });
  // }
  // fetchAllUrls(): void {
  //   this.loaderdata = true;
  //   const request1 = this.searchitem.basesearch('*&$top=1000');
  //   const request2 = this.searchitem.basesearch('%2A&$top=500&$skip=1000');
  
  //   forkJoin([request1, request2]).subscribe(([response1, response2]) => {
  //     const urls: { name: string; url: string }[] = [];
  
  //     if (response1?.value?.length > 0) {
  //       response1.value.forEach((element: any) => {
  //         const name = element.metadata_storage_name.split('.')[0];
  //         const url = element.wfileurl;
  //         urls.push({ name, url });
  //       });
  //     }
  
  //     if (response2?.value?.length > 0) {
  //       response2.value.forEach((element: any) => {
  //         const name = element.metadata_storage_name.split('.')[0];
  //         const url = element.wfileurl;
  //         urls.push({ name, url });
  //       });
  //     }
  
  //     this.allUrls = urls;
  //     this.loaderdata = false;
  
  //     const length = this.allUrls.length;
  //     console.log("Total URLs:", length);
  //    // console.log("All URLs:", this.allUrls);
  
  //     // Extract filenames
  //     const filenames: string[] = this.allUrls.map(url => url.url.split("/").pop());
  //     console.log("Filenames:", filenames);
      
  //     // Continue with other logic if needed
  //   });
  // }
  

   //both url and names log
  //  fetchAllUrls(): void {
  //   this.loaderdata = true;
  //   const request1 = this.searchitem.basesearch('*&$top=1000');
  //   const request2 = this.searchitem.basesearch('%2A&$top=500&$skip=1000');
  
  //   forkJoin([request1, request2]).subscribe(([response1, response2]) => {
  //     const metadataNames: string[] = [];
  //     const urls: string[] = [];
  
  //     if (response1?.value?.length > 0) {
  //       response1.value.forEach((element: any) => {
  //         const name = element.metadata_storage_name.split('.')[0];
  //         const url = element.wfileurl;
  //         metadataNames.push(name);
  //         urls.push(url);
  //       });
  //     }
  
  //     if (response2?.value?.length > 0) {
  //       response2.value.forEach((element: any) => {
  //         const name = element.metadata_storage_name.split('.')[0];
  //         const url = element.wfileurl;
  //         metadataNames.push(name);
  //         urls.push(url);
  //       });
  //     }
  
  //     this.allUrls = urls.map((url, index) => ({ name: metadataNames[index], url }));
  //     this.loaderdata = false;
  
  //     const length = this.allUrls.length;
  //     console.log("Total URLs:", length);
  //     console.log("Metadata Names:");
  //     metadataNames.forEach((name, index) => {
  //       console.log(`${name}`);
  //     });
  //     console.log("URLs:");
  //     urls.forEach((url, index) => {
  //       console.log(` ${url}`);
  //     });
  
  //     // Continue with other logic if needed
  //   });
  // }
  